// extracted by mini-css-extract-plugin
module.exports = {"cz9frdq":"cz9frdq"};